import { z } from 'zod';

const PageSchema = z.object({
  id: z.string(),
  title: z.string(),
  url: z.string(),
  new_window: z.boolean().optional(),
});

export type FooterNavigationPage = z.infer<typeof PageSchema>;

const FooterNavigationItemSchema: z.ZodType<any> = z.lazy(() =>
  z.object({
    page: PageSchema,
    depth: z.number().positive(),
    children: z.array(FooterNavigationItemSchema),
  })
);

export interface FooterNavigationItem {
  page: FooterNavigationPage;
  depth: number;
  children: FooterNavigationItem[];
}

const FooterNavigationSchema = z.object({
  data: z.array(FooterNavigationItemSchema),
});

export type FooterNavigationResponse = z.infer<typeof FooterNavigationSchema>;

export { FooterNavigationSchema };
